import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const GoogleButton = () => {
  const startGoogle = () => {
    const redirect = `${window.location.origin}/app`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <button
      type="button"
      onClick={startGoogle}
      data-testid="google-login-button"
      className="w-full flex items-center justify-center gap-3 rounded-full border border-reveal-rose/40 bg-black/30 text-reveal-cream py-3 font-body hover:bg-reveal-rose/10 transition-colors"
    >
      <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" />
      Continue with Google
    </button>
  );
};

export const fieldClass =
  "w-full bg-black/40 border border-reveal-rose/40 rounded-xl px-4 py-3 font-body text-reveal-cream placeholder:text-reveal-cream/40 outline-none focus:border-reveal-rose transition-colors";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login({ email: email.trim(), password });
      navigate(data.role === "admin" ? "/admin" : "/app", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-reveal-black text-reveal-cream font-body flex items-center justify-center px-5" data-testid="login-page">
      <div className="w-full max-w-sm">
        <Link to="/landing" className="block text-center mb-8">
          <span className="font-heading text-3xl text-reveal-rose">Reveal</span>
        </Link>
        <form onSubmit={submit} className="bg-reveal-burgundy border border-reveal-rose/20 rounded-3xl px-8 py-9" data-testid="login-form">
          <h1 className="font-heading text-3xl text-reveal-cream mb-1">Welcome back</h1>
          <p className="text-sm text-reveal-cream/55 mb-7">Sign in to continue</p>

          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input" className={`${fieldClass} mb-4`} />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input" className={`${fieldClass} mb-5`} />

          {error && <p className="text-sm text-red-400 mb-4" data-testid="login-error">{error}</p>}

          <button type="submit" disabled={loading} data-testid="login-submit-button"
            className="w-full bg-reveal-rose text-black font-medium py-3 rounded-full hover:bg-[#c9987b] transition-colors disabled:opacity-60 mb-4">
            {loading ? "Signing in..." : "Sign In"}
          </button>

          <div className="flex items-center gap-3 my-5">
            <div className="h-px flex-1 bg-reveal-rose/15" />
            <span className="text-xs text-reveal-cream/40">or</span>
            <div className="h-px flex-1 bg-reveal-rose/15" />
          </div>

          <GoogleButton />

          <p className="text-sm text-reveal-cream/55 text-center mt-6">
            No account?{" "}
            <Link to="/signup" className="text-reveal-rose hover:text-reveal-cream transition-colors" data-testid="go-to-signup">
              Create one
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
